"use client";

import { Button } from "@cmp-src/primitives/button";
import { Modal } from "@gettactic/components/src/overlay/modals/Modal";
import { Copy } from "lucide-react";
import React, { useCallback } from "react";

interface RegistrationCodeModalProps {
  code: string | null;
  onClose: () => void;
}

export const RegistrationCodeModal: React.FC<RegistrationCodeModalProps> = ({
  code,
  onClose
}) => {
  const handleCopyCode = useCallback(async () => {
    if (!code) return;
    await navigator.clipboard.writeText(code);
    onClose();
  }, [code, onClose]);

  return (
    <Modal
      isOpen={code !== null}
      onClose={onClose}
      title="Visitor Pre-Registered"
      description="An email has been sent to the visitor with a pre-registration code. For reference, this is the code the visitor will use upon arriving at the office."
      size="sm"
    >
      <div className="flex flex-col items-center gap-4 py-2">
        <div className="rounded-lg bg-neutral-100 px-6 py-4 font-bold font-mono text-2xl tracking-widest">
          {code}
        </div>
        <div className="flex items-center gap-2">
          <Button variant="outline" className="gap-2" onClick={handleCopyCode}>
            <Copy className="h-4 w-4" />
            Copy Code
          </Button>
          <Button onClick={onClose}>Ok</Button>
        </div>
      </div>
    </Modal>
  );
};
